module.exports = __webpack_public_path__ + "img/3.82841d76.jpg";